import React, { useState } from 'react';
import { required, minLength, email, Edit, SimpleForm, TextInput, SelectInput, useRedirect } from 'react-admin';
import DataProvider from '../../DataProvider.js'
import useUser from '../../hooks/useUser';
import EditConfirmToolbar from '../../components/EditConfirmToolbar'
import ListSelect from '../../components/ListSelect'
import { parse } from "query-string";

function matchesNewPassword(value, allValues) {
    if (!value) return undefined
    const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{10,})/
    if (!passwordRegex.test(value)) {
        return "Password must contain at least 1 uppercase letter, 1 number, 1 special character, and be at least 10 characters long"
    }
    if (value !== allValues.newPassword) {
        return "Password and Password Confirmation don't match"
    }
    return undefined
}

const UserEdit = (props, { resource }) => {

    const user = useUser()
    const { organization_id } = parse(props.location.search);

    let [hide, changeHide] = useState(false)
    const hidePW = () => changeHide(true)

    const alertM = `Warning, this cannot be undone. This user will be deleted permanently.`

    const redirectTo = useRedirect();

    const [orgs, setOrgs] = useState([])
    const updateOrgs = (data) => setOrgs(data)

    const editUser = async (data) => {
        if (data.role === 'super-admin') {
            data.superPW = confirmSuperAdmin()
        }
        await uploadData(data)
    }

    const confirmSuperAdmin = () => {
        return window.prompt('WARNING! You are attempting to edit a super admin, if you wish to continue you must enter your password.');
    }

    const uploadData = async (data) => {
        let _orgs = []
        if (orgs && orgs.length > 0) for (let org of orgs) _orgs.push(org.id)
        try {
            const cL = await DataProvider.update('users', { id: data.id, data: { ...data, organization_ids: _orgs }, })
            redirectTo(`/users/${cL.data.id}/show?organization_id=${organization_id}`, cL)
        } catch (e) {
            alert('The user was not edited. You may be unauthorized to edit this user, or the password you entered while editing this user was incorrect.')
        }
    }

    if (user.role === 'super-admin' || user.id) {
        return (<Edit {...props} title="Edit User">
            <SimpleForm toolbar={<EditConfirmToolbar handlesave={editUser} tbredirect='/users' alertmessage={alertM} dataprovidersource='users' history={props.history} />}>
                <TextInput fullWidth label="First Name" source="firstName" validate={[required()]} />
                <TextInput fullWidth label="Last Name" source="lastName" validate={[required()]} />
                <TextInput fullWidth label="Email" source="email" validate={[email(), required()]} />
                {user.role === 'super-admin' ?
                    <SelectInput fullWidth label="Role" source="role" choices={[
                        { id: 'super-admin', name: 'Super Admin' },
                        { id: 'channel-admin', name: 'Channel Admin' },
                        { id: 'org-admin', name: 'Organization Admin' },
                    ]} validate={[required()]} />
                    : null}
                <TextInput fullWidth label="Change Password?" type={hide ? "password" : ""} source="newPassword" onChange={() => hidePW()} validate={[minLength(10)]} />
                <TextInput fullWidth label="Change Password Confirmation" type={hide ? "password" : ""} source="newPasswordConfirm" onChange={() => hidePW()} validate={[minLength(10), matchesNewPassword]} />
                {(user.role === 'super-admin' || user.role === 'channel-admin') &&
                    <ListSelect
                        {...props}
                        headers={['Name']}
                        sources={['name']}
                        filters={[{ source: 'name', placeholder: 'Add organization by name:' }]}
                        filterorgid={false}
                        target="Organizations"
                        selectedsource="organization_ids"
                        updatestate={updateOrgs} />}
            </SimpleForm>
        </Edit>)
    } else {
        return (<div />)
    }
}

export default UserEdit